<template lang="pug">
  .mt-4
    v-dialog(v-model='dialog', max-width='1000')
      template(v-slot:activator='{ on }')
        v-btn.mb-2(color='primary', dark='', v-on='on') Add select items
      v-card
        v-card-title
          span.headline {{ formTitle }}
        v-card-text
          v-container
            v-row(align='center')
              v-col(md='6')
                v-text-field(v-model='editedItem.name', label='Name' outlined hide-details)
              v-col(md='3')
                v-btn(color='primary' block @click='paste') Paste
              v-col(md='12')
                v-text-field(v-model='input', label='Add item' outlined hide-details @keydown.enter='addValue')
              v-col(md='12' v-if='editedItem.values!=""')
                v-chip.mr-2.mb-2(v-for='(value, i) in editedItem.values.split(",,")' :key='i' :close='true' @click:close='deleteValue(value)') {{value}}
        v-card-actions
          v-spacer
          v-btn(text @click='close') Cancel
          v-btn(text @click='save') Save
    v-list
      v-list-item(v-for="item in selects" :key="item.ID")
        v-list-item-content
          v-list-item-title(v-text="item.name")
        v-list-item-action
          .d-flex
            v-btn(icon @click='editItem(item)')
              v-icon(color="grey lighten-1" ) mdi-pencil
            v-btn(icon)
              v-icon(color="grey lighten-1") mdi-delete
</template>
<script>
export default {
  data() {
    return {
      selects: [],
      dialog: false,
      editedIndex: -1,
      input: "",
      editedItem: {
        name: "",
        values: "",
      },
      defaultItem: {
        name: "",
        values: "",
      },
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  mounted() {
    this.getSelects()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.selects.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    addItem() {
      this.axios.post("/admin/selects", this.editedItem).then(() => {
        this.getSelects()
        this.close()
      })
    },
    save () {
      if (this.editedIndex > -1) {
        this.updateItem()
      } else {
        this.addItem()
      }
    },
    updateItem() {
      this.axios.put("/admin/selects", this.editedItem).then(() => {
        this.getSelects()
        this.close()
      })
    } ,
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    paste() {
      navigator.clipboard.readText()
      .then(text => {
        this.editedItem.values = text.split("\n").join(",,")
      })
      .catch(err => {
        this.$message.error('Failed to read clipboard contents: ' + err)
      });
    },
    deleteValue(value) {
      this.editedItem.values = this.editedItem.values.split(",,").filter(v => v!=value).join(",,")
    },
    addValue() {
      this.editedItem.values == ""?
        this.editedItem.values = this.input :
        this.editedItem.values += ",," + this.input
      this.input = ""
    },
    getSelects() {
      this.axios.get("/admin/selects").then(resp => {
        this.selects = resp.data
      })
    }
  }
}
</script>